import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Button,
    TextField,
    CircularProgress,
    Typography,
    FormControlLabel,
    Checkbox,
    InputAdornment,
    IconButton,
    Grid,
} from "@material-ui/core";

import Alert from '@material-ui/lab/Alert';

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import FloatingContainer from "src/shared_modules/veu-visitors-core/components/common/container/floatingContainer";
import ScrollContainer from "src/shared_modules/veu-visitors-core/components/common/container/scrollContainer";

import LinkInText from "src/shared_modules/veu-visitors-core/components/common/link-in-text";
import CountrySelect from "src/shared_modules/veu-visitors-core/components/common/country-select";
import FoaSelect,{ formOfAdressCodeToI18nValue } from "src/shared_modules/veu-visitors-core/components/common/foa-select";

import MarketingConsentButton from "src/shared_modules/veu-visitors-core/components/common/marketingConsentButton";
import TokenValidationComponent from "src/shared_modules/veu-visitors-core/components/common/token-validation";

import {
    Translate,
    currentLanguage,
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    registerTest,
    registerNow,
} from 'src/shared_modules/veu-visitors-core/actions/user';

import {
    fetchToken,
    validateToken
} from 'src/shared_modules/veu-visitors-core/actions/token';

import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';


import './user.css';

class PopoverRegister extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            error : "",
            canSend : true,
            isBusy : false,
            failed: false,
            showPassword : false,
            isValidating: false,
            isValidated: false,
            validateFailed: false,
            code: "",
            fields: {
                username : "",
                email : "",
                password : "",
                passwordRepeat : "",
                acceptAgreement : false,
                acceptAgreement2 : false,
                formOfAdress: "",
                title : "",
                firstname : "",
                lastname : "",
                company : "",
                position : "",
                country : "",
                city : "",
                division : "",
                department : "",
                phone : "",
            },
            fieldErrors : {
            },
        }

        this.clickSend = this.clickSend.bind(this);
        this.handleValidateToken = this.handleValidateToken.bind(this);

    }

    componentDidMount() {

    }

    clickCancel() {
        // TODO send cancel to Plazz API if isBusy = true

        this.setState({
            isBusy: false,
            showPassword : false,
            isValidating: false,
            isValidated: false,
            validateFailed: false,
            code: "",
            fields: {
                username : "",
                email : "",
                password : "",
                passwordRepeat : "",
                acceptAgreement : false,
                acceptAgreement2 : false,
                firstname : "",
                lastname : "",
                formOfAdress: "",
                title : "",
                company : "",
                position : "",
                country : "",
                city : "",
                division : "",
                department : "",
                phone : "",
            },
            fieldErrors : {
            },
            error: "", // errorcode
            canSend: false,
            failed: false,
        });
        this.props.hidePopover("Register");
        this.props.showPopover("Login");
    }

    async clickSend() {
        if( this.state.isBusy || !this.state.canSend )
            return;

        if (this.state.isValidated) {
            this.registerNewUser();
        }
        else {
            let error = await this.props.registerTest(
                    this.state.fields
                );

            if( error !== false ) {

                this.setState({
                    failed: true,
                    isBusy: false,
                    error: "popovers.register.failed." + error,
                    fieldErrors :  this.markFieldErrors(error)
                });

                return;
            }

            let currentLangi18n = currentLanguage();
            this.props.fetchToken(this.state.fields["email"], currentLangi18n.code2, {
                firstname: this.state.fields["firstname"],
                lastname: this.state.fields["lastname"],
                formOfAdress: formOfAdressCodeToI18nValue(this.state.fields["formOfAdress"]),
                eventname: this.props.event.name[currentLangi18n.code2]
            });
            this.setState({
                isValidating: true
            });
        }
    }

    async handleValidateToken( code ) {
        if (this.state.isBusy)
            return;

        this.setState({
            isBusy: true,
        });

        await this.props.validateToken(this.props.token.tokenId, code);

        this.setState({
            isBusy: false,
        });

        if (this.props.token.isTokenValid) {
          this.setState({
              isValidating: false,
              validateFailed: false,
              isValidated: true,
          });
          this.registerNewUser();
        }
        else {
          this.setState({
              isValidating: true,
              validateFailed: true,
              isValidated: false,
          });
        }
    }

    async registerNewUser() {

        this.setState({
            isBusy: true,
            failed: false,
            error: "",
        });

        let error = await this.props.registerNow(
                this.state.fields
            );

        if( error !== false ) {

            this.setState({
                failed: true,
                isBusy: false,
                error: "popovers.register.failed." + error,
                fieldErrors :  this.markFieldErrors(error)
            });

        } else {
            this.setState({
                isBusy: false,
                isValidating: false,
                isValidated: false,
                validateFailed: false,
                code: "",
                fields: {
                    username : "",
                    email : "",
                    password : "",
                    passwordRepeat : "",
                    acceptAgreement : false,
                    acceptAgreement2 : false,
                    firstname : "",
                    lastname : "",
                    formOfAdress:"",
                    title : "",
                    company : "",
                    position : "",
                    country : "",
                    division : "",
                    department : "",
                    phone : "",
                },
                canSend: false
            });
            this.props.hidePopover("Register");
            this.props.trackEvent("register","success","local");
            this.props.showPopover("RegisterSuccess");
        }

    }

    markFieldErrors( errorcode ) {
        let fieldErrors = {};
        if( errorcode === "passwordDoesNotMatch" ) {
            fieldErrors["password"] = true;
            fieldErrors["passwordRepeat"] = true;
        } else if( errorcode === "dublicateUsername" ) {
            fieldErrors["username"] = true;
        } else if( errorcode === "weakPassword" ) {
            fieldErrors["password"] = true;
        } else  {
            // maybe we have additional error codes from plazz here

            // but in all other cases we mark the fields
            fieldErrors[errorcode] = true;
        }
        return fieldErrors;
    }

    validateInput(value) {
        // just not empty
        if( value === undefined || value === null || value.trim() === "" )
            return false;

        return true;
    }

    validateFields() {
        let canSend = true;
        let fields = this.state.fields;

        if( !this.validateInput(fields["username"]) )
            canSend = false;

        if( !this.validateInput(fields["password"]) )
            canSend = false;

        if( !this.validateInput(fields["passwordRepeat"]) )
            canSend = false;

        if( !this.validateInput(fields["firstname"]) )
            canSend = false;

        if( !this.validateInput(fields["lastname"]) )
            canSend = false;

        if( !this.validateInput(fields["country"]) )
            canSend = false;

        if( fields["acceptAgreement"] === false )
            canSend = false;

        if( fields["acceptAgreement2"] === false )
            canSend = false;

        return canSend;
    }

    handleInputChange( field, event ) {
        event.preventDefault();
        // update the field value
        let fields = this.state.fields;
        let val = event.target.value;
        fields[field] = val;
        console.warn("val: " + val);

        let canSend = this.validateFields();

        if (field === "email") {
          this.setState({
                  isValidated: false,
              });
        }
        this.setState({
                fields : fields,
                canSend : canSend,
                fieldErrors: {},
            });
    }

    handleCodeInputChange( event ) {
        event.preventDefault();
        let val = event.target.value;
        this.setState({
                code: val,
            });
    }

    handleCheckChange( field, event ) {
        // update the field value
        let fields = this.state.fields;
        fields[event.target.name] = event.target.checked;

        let canSend = this.validateFields();

        this.setState({
                fields : fields,
                canSend : canSend,
                fieldErrors: {},
            });
    }

    togglePasswordVisibility() {
        this.setState({ showPassword : !this.state.showPassword });
    }



    renderHeader() {
        return(<React.Fragment>
                    <Typography variant="h4" component="h1" color="primary" className="user-form none-scroll">
                        <Translate>popovers.register.title</Translate>
                    </Typography>
                    {this.state.failed &&<React.Fragment>
                        <Alert variant="outlined" severity="error" className="none-scroll">
                            <Translate>{this.state.error}</Translate>
                        </Alert>
                        <p></p>
                    </React.Fragment>}
            </React.Fragment>);
    }

    renderButtonBar() {
        return(<div className="user-form-button-bar none-scroll">
                    <Button variant="contained"
                            color="secondary"
                            size="large"
                            onClick={() =>{ this.clickSend();} }
                            disabled={!this.state.canSend}
                            type="submit"
                            endIcon={ this.state.isBusy && <CircularProgress color="inherit" size={20} /> }
                        >
                        <Translate>popovers.register.send</Translate>
                    </Button>
                    <Button color="primary"
                            size="large"
                            onClick={() =>{ this.clickCancel();} }
                        >
                        <Translate>popovers.register.cancel</Translate>
                    </Button>
                    <div className="marketing-consent-button">
                        <MarketingConsentButton />
                    </div>
            </div>);
    }



    renderAccount() {
        return(<Grid container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    spacing={1}
                >
                <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary" component="div">
                        <Translate>popovers.register.titleAccount</Translate>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="caption" component="div" className="light-grey-text">
                        <Translate>popovers.register.noteUsername</Translate>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField id="email" key="email"
                            required
                            fullWidth
                            label={<Translate>person-labels.email</Translate>}
                            variant="outlined"
                            type="email"
                            value={this.state.fields["email"]}
                            error={this.state.fieldErrors["email"]}
                            onChange={(e)=>{this.handleInputChange("email",e);}}
                        />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField id="username" key="username"
                            required
                            fullWidth
                            label={<Translate>person-labels.username</Translate>}
                            variant="outlined"
                            value={this.state.fields["username"]}
                            error={this.state.fieldErrors["username"]}
                            onChange={(e)=>{this.handleInputChange("username",e);}}
                        />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField id="password"  key="password"
                            required
                            fullWidth
                            label={<Translate>person-labels.password</Translate>}
                            variant="outlined"
                            value={this.state.fields["password"]}
                            error={this.state.fieldErrors["password"]}
                            onChange={(e)=>{this.handleInputChange("password",e);}}
                            type={this.state.showPassword ? 'text' : 'password'}
                            InputProps={{ endAdornment:
                                <InputAdornment position="end">
                                    <IconButton aria-label="toggle password visibility"
                                            onClick={()=> this.togglePasswordVisibility() }
                                            edge="end"
                                        >
                                        { this.state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            } }
                        />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField id="passwordRepeat"  key="passwordRepeat"
                            required
                            fullWidth
                            label={<Translate>person-labels.password-repeat</Translate>}
                            variant="outlined"
                            value={this.state.fields["passwordRepeat"]}
                            error={this.state.fieldErrors["passwordRepeat"]}
                            onChange={(e)=>{this.handleInputChange("passwordRepeat",e);}}
                            type={this.state.showPassword ? 'text' : 'password'}
                            InputProps={{ endAdornment:
                                <InputAdornment position="end">
                                    <IconButton aria-label="toggle password visibility"
                                            onClick={()=> this.togglePasswordVisibility() }
                                            edge="end"
                                        >
                                        { this.state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            } }
                        />
                </Grid>
            </Grid>);
    }


    renderPersonal() {
        let isVisible = this.props.visibleUserProfileFields;

        return(<Grid container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    spacing={1}
                >
                <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary" component="div">
                        <Translate>popovers.register.titleProfile</Translate>
                    </Typography>
                </Grid>
                { isVisible.formOfAdress && <Grid item xs={12} md={6}>
                    <FoaSelect
                            value={this.state.fields["formOfAdress"]}
                            onChange={(e)=>{this.handleInputChange("formOfAdress",e);}}
                        />
                </Grid> }
                { isVisible.title && <Grid item xs={12} md={6}>
                    <TextField id="title"  key="title"
                            fullWidth
                            label={<Translate>person-labels.title</Translate>}
                            variant="outlined"
                            value={this.state.fields["title"]}
                            onChange={(e)=>{this.handleInputChange("title",e);}}
                        />
                </Grid> }
                <Grid item xs={12} md={6}>
                    <TextField id="firstname"  key="firstname"
                            required
                            fullWidth
                            label={<Translate>person-labels.firstname</Translate>}
                            variant="outlined"
                            value={this.state.fields["firstname"]}
                            error={this.state.fieldErrors["firstname"]}
                            onChange={(e)=>{this.handleInputChange("firstname",e);}}
                        />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField id="lastname"  key="lastname"
                            required
                            fullWidth
                            label={<Translate>person-labels.lastname</Translate>}
                            variant="outlined"
                            value={this.state.fields["lastname"]}
                            error={this.state.fieldErrors["lastname"]}
                            onChange={(e)=>{this.handleInputChange("lastname",e);}}
                        />
                </Grid>

                { isVisible.company && <Grid item xs={12} md={6}>
                    <TextField id="company"  key="company"
                            fullWidth
                            label={<Translate>person-labels.company</Translate>}
                            variant="outlined"
                            value={this.state.fields["company"]}
                            onChange={(e)=>{this.handleInputChange("company",e);}}
                        />
                </Grid> }
                { isVisible.department && <Grid item xs={12} md={6}>
                    <TextField id="department"  key="department"
                            fullWidth
                            label={<Translate>person-labels.department</Translate>}
                            variant="outlined"
                            value={this.state.fields["department"]}
                            onChange={(e)=>{this.handleInputChange("department",e);}}
                        />
                </Grid> }
                { isVisible.division && <Grid item xs={12} md={6}>
                    <TextField id="division"  key="division"
                            fullWidth
                            label={<Translate>person-labels.division</Translate>}
                            variant="outlined"
                            value={this.state.fields["division"]}
                            onChange={(e)=>{this.handleInputChange("division",e);}}
                        />
                </Grid> }
                { isVisible.positon && <Grid item xs={12} md={6}>
                    <TextField id="positon"  key="positon"
                            fullWidth
                            label={<Translate>person-labels.position</Translate>}
                            variant="outlined"
                            value={this.state.fields["position"]}
                            onChange={(e)=>{this.handleInputChange("position",e);}}
                        />
                </Grid> }
                <Grid item xs={12} md={6}>
                    <CountrySelect
                            required
                            value={this.state.fields["country"]}
                            onChange={(e)=>{this.handleInputChange("country",e);}}
                        />
                </Grid>
                { isVisible.city && <Grid item xs={12} md={6}>
                    <TextField id="city"  key="city"
                            fullWidth
                            label={<Translate>person-labels.city</Translate>}
                            variant="outlined"
                            value={this.state.fields["city"]}
                            onChange={(e)=>{this.handleInputChange("city",e);}}
                        />
                </Grid> }

                { isVisible.phone && <Grid item xs={12} md={6}>
                    <TextField id="phone"  key="phone"
                            fullWidth
                            label={<Translate>person-labels.phone</Translate>}
                            variant="outlined"
                            value={this.state.fields["phone"]}
                            onChange={(e)=>{this.handleInputChange("phone",e);}}
                        />
                </Grid> }

                <Grid item xs={12}>
                    <Typography variant="caption" component="div" className="light-grey-text">
                        <Translate>popovers.register.noteMantatory</Translate>
                    </Typography>
                </Grid>
            </Grid>);
    }

    renderLegal() {
        return(<Grid container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    spacing={1}
                >
                <Grid item xs={12}>
                    <FormControlLabel
                            control={
                                <Checkbox checked={this.state.fields["acceptAgreement"]}
                                        onChange={(e)=>{this.handleCheckChange("acceptAgreement",e);}}
                                        name="acceptAgreement"
                                        color="secondary"
                                    />
                            }
                            label={
                                <LinkInText staticUrls={["therms-of-use.html"]} isI18n label="popovers.register.accept" />
                            }
                        />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                            control={
                                <Checkbox checked={this.state.fields["acceptAgreement2"]}
                                        onChange={(e)=>{this.handleCheckChange("acceptAgreement2",e);}}
                                        name="acceptAgreement2"
                                        color="secondary"
                                    />
                            }
                            label={
                                <LinkInText staticUrls={["privacy-policy.html"]} isI18n  label="popovers.register.accept2" />
                            }
                        />
                </Grid>
                <Grid item xs={12}>
                <Typography variant="body2" className="light-grey-text">
                    <LinkInText staticUrls={["privacy-policy.html"]} isI18n  label="popovers.register.legal-text" />
                </Typography>
                <Typography variant="body2" className="light-grey-text">
                    <LinkInText isI18n  label="popovers.register.support-text" />
                </Typography>
                </Grid>
            </Grid>);
    }

    render() {
        if( !this.props.showRegister )
            return(null);

        if (this.state.isValidating) {
            return (<FloatingContainer position="center"
                            width="lg"
                            fsSwitch="md"
                            className="user fixed-height outer-flex-scroll-container"
                            modal
                            largeBottomPadding={this.props.event.hasUserlike}
                        >
                        <TokenValidationComponent
                                isBusy={this.state.isBusy}
                                validate={this.handleValidateToken}
                                validateFailed={this.state.validateFailed }
                                trackingName="register"
                        />
                </FloatingContainer>);
        }

        return (<FloatingContainer position="center"
                        width="lg"
                        fsSwitch="md"
                        className="user fixed-height outer-flex-scroll-container"
                        modal
                        onClickAway={()=> { this.clickCancel();}}
                        largeBottomPadding={this.props.event.hasUserlike}
                    >
                    { this.renderHeader() }
                    <ScrollContainer className="user-register">
                        <form onSubmit={(e)=>{e.preventDefault();} } >
                            { this.renderAccount() }
                            <br />
                            { this.renderPersonal() }
                            { this.renderLegal() }
                        </form>
                    </ScrollContainer>
                    { this.renderButtonBar() }
            </FloatingContainer>);
    }
}

PopoverRegister.propTypes = {
    showRegister: PropTypes.bool,
    visibleUserProfileFields: PropTypes.object,
    event: PropTypes.object,
    token : PropTypes.object,
};


/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        showRegister : state.popovers.showRegister,
        visibleUserProfileFields : state.event.visibleUserProfileFields,
        event : state.event,
        token: state.token,
    };
};
const mapDispatchToProps = {
    showPopover,
    hidePopover,
    registerTest,
    registerNow,
    fetchToken,
    validateToken,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withMatomo(PopoverRegister));
